import { useMemo } from 'react';

import { keyOf, NameAndCreateDateFormatter } from '@Components/Grid/components/Table/formatters';
import column, { defaultActionsColumn, editAction, defaultColumnId, defaultActiveColumn } from '@Components/Grid/utils/column';

import DeleteEntryWithReferences from './DeleteEntryWithReferences';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    column.accessor('name', {
      header: 'Description',
      cell: info => <NameAndCreateDateFormatter info={info} />,
      initialSize: 'min-w-[65vw]',
    }),
    column.accessor('external_id', {
      header: 'External-ID Key',
      cell: info => info.getValue() || '--',
    }),
    defaultActiveColumn(),
    defaultActionsColumn(editAction, deleteAction),
  ], [])
}

function deleteAction(info) {
  return <DeleteEntryWithReferences key={keyOf(info, 'delete')} info={info} />
}
